"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredConfig = exports.defaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const defaultConfig = () => {
    return {
        containerId: "",
        titleFull: {
            en_CA: "List of cookies",
            en_US: "List of cookies",
            fr_CA: "Liste des cookies",
        },
        titleSmall: {
            en_CA: "We respect your privacy",
            en_US: "We respect your privacy",
            fr_CA: "Nous respectons votre vie privée",
        },
        descriptionFull: {
            en_CA: "A cookie is a small data file (text file) that a website, when visited by a user, asks your browser to store on your device in order to remember information about you, such as your preferences. language or connection information. More specifically, we use cookies and other tracking technologies for the following purposes:",
            en_US: "A cookie is a small data file (text file) that a website, when visited by a user, asks your browser to store on your device in order to remember information about you, such as your preferences. language or connection information. More specifically, we use cookies and other tracking technologies for the following purposes:",
            fr_CA: "Un cookies est un petit fichier de données (fichier texte) qu'un site Web, lorsqu'il est consulté par un utilisateur, demande à votre navigateur de stocker sur votre appareil afin de mémoriser des informations vous concernant, telles que vos préférences linguistiques ou informations de connexion. Plus concrètement, nous utilisons des témoins et d'autres technologies de suivi selon les finalités suivantes :",
        },
        descriptionSmall: {
            en_CA: "With your consent, we use cookies to improve your browsing experience, deliver personalized ads or content, and analyze visits to this website.",
            en_US: "With your consent, we use cookies to improve your browsing experience, deliver personalized ads or content, and analyze visits to this website.",
            fr_CA: "Avec votre consentement, nous utilisons des cookies pour améliorer votre expérience de navigation, diffuser des publicités ou des contenus personnalisés et analyser les visites à ce site Web. En cliquant sur « Tout accepter », vous consentez [à notre politique de confidentialité et cookies.](https://www.drolet.ca/ca/fr/politiques-de-confidentialite-et-cookies/)",
        },
        innerButtonPersonalized: {
            en_CA: react_1.default.createElement(react_1.default.Fragment, null, "Personalize"),
            en_US: react_1.default.createElement(react_1.default.Fragment, null, "Personalize"),
            fr_CA: react_1.default.createElement(react_1.default.Fragment, null, "Personnaliser"),
        },
        innerButtonAcceptAll: {
            en_CA: react_1.default.createElement(react_1.default.Fragment, null, "Accept all"),
            en_US: react_1.default.createElement(react_1.default.Fragment, null, "Accept all"),
            fr_CA: react_1.default.createElement(react_1.default.Fragment, null, "Tout accepter"),
        },
        textAlwaysActive: {
            en_CA: "ALWAYS ACTIVE",
            en_US: "ALWAYS ACTIVE",
            fr_CA: "TOUJOURS ACTIFS",
        },
        cookieConsentPreferences: [
            {
                isAlwaysActive: true,
                cookieConsentPreferencesName: "necessary",
                title: {
                    en_CA: "Essential",
                    en_US: "Essential",
                    fr_CA: "Essentiels",
                },
                description: {
                    en_CA: "These cookies are necessary for the website to function and cannot be disabled in our systems. They are generally established as a response to actions you have taken that constitute a request for services, such as setting your privacy preferences, logging in or filling out forms. These cookies do not store any personally identifying information.",
                    en_US: "These cookies are necessary for the website to function and cannot be disabled in our systems. They are generally established as a response to actions you have taken that constitute a request for services, such as setting your privacy preferences, logging in or filling out forms. These cookies do not store any personally identifying information.",
                    fr_CA: "Ces cookies sont nécessaires au fonctionnement du site Web et ne peuvent pas être désactivés dans nos systèmes. Ils sont généralement établis en tant que réponse à des actions que vous avez effectuées et qui constituent une demande de services, telles que la définition de vos préférences en matière de confidentialité, la connexion ou le remplissage de formulaires. Ces témoins ne stockent aucune information d’identification personnelle.",
                },
            },
            {
                isAlwaysActive: false,
                cookieConsentPreferencesName: "functionality",
                title: {
                    en_CA: "Functional",
                    en_US: "Functional",
                    fr_CA: "Fonctionnels",
                },
                description: {
                    en_CA: "Functional cookies are used to facilitate your browsing experience, for example your choices of store (Canada or United States) or currency (CAD or USD).",
                    en_US: "Functional cookies are used to facilitate your browsing experience, for example your choices of store (Canada or United States) or currency (CAD or USD).",
                    fr_CA: "Les cookies fonctionnels servent à faciliter votre expérience de navigation, par exemple vos choix de magasin (Canada ou États-Unis) ou de devise (CAD ou USD).",
                },
            },
            {
                isAlwaysActive: false,
                cookieConsentPreferencesName: "analytics",
                title: {
                    en_CA: "Analytics",
                    en_US: "Analytics",
                    fr_CA: "Analytiques",
                },
                description: {
                    en_CA: "Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information about the number of visitors, traffic source, etc.",
                    en_US: "Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information about the number of visitors, traffic source, etc.",
                    fr_CA: "Les cookies analytiques sont utilisés pour comprendre comment les visiteurs interagissent avec le site Web. Ces cookies aident à fournir des informations sur le nombre de visiteurs, la source de trafic, etc.",
                },
            },
            {
                isAlwaysActive: false,
                cookieConsentPreferencesName: "advertising",
                title: {
                    en_CA: "Advertising",
                    en_US: "Advertising",
                    fr_CA: "Publicité",
                },
                description: {
                    en_CA: "Advertising cookies may be used to build a profile of your interests and provide you with relevant advertisements. They do not store personal data directly, but are based on the unique identification of your browser and Internet device. If you do not allow these cookies, your advertising will be less targeted.",
                    en_US: "Advertising cookies may be used to build a profile of your interests and provide you with relevant advertisements. They do not store personal data directly, but are based on the unique identification of your browser and Internet device. If you do not allow these cookies, your advertising will be less targeted.",
                    fr_CA: "Les cookies de publicité peuvent être utilisés pour établir un profil de vos intérêts et vous proposer des publicités pertinentes. Ils ne stockent pas directement des données personnelles, mais sont basés sur l'identification unique de votre navigateur et de votre appareil Internet. Si vous n'autorisez pas ces cookies, votre publicité sera moins ciblée.",
                },
            },
        ],
    };
};
exports.defaultConfig = defaultConfig;
const getFilteredConfig = (cookieConsentConfig) => {
    var _a;
    let newConfig = (0, exports.defaultConfig)();
    for (const keysOfCookieConsentConfig in newConfig) {
        const key = keysOfCookieConsentConfig;
        newConfig[key] = ((_a = cookieConsentConfig[key]) !== null && _a !== void 0 ? _a : newConfig[key]);
    }
    return newConfig;
};
exports.getFilteredConfig = getFilteredConfig;
//# sourceMappingURL=cookiesConsentProviderConfig.js.map